import { ArrowUpRight } from "lucide-react";
import Reveal, { fadeUp } from "@/components/motion/Reveal";

const partners = [
  {
    name: "FocusR",
    url: "https://focusrtech.com",
    tagline: "Global Oracle · SAP · AI transformation partner — 12+ years, 225+ clients.",
    role: "Strategic Product & ERP Partner",
  },
];

export default function Partners() {
  return (
    <section id="partners" data-testid="partners-section" className="section-pad bg-surface-muted relative">
      <div className="absolute inset-0 noise-overlay pointer-events-none" aria-hidden />
      <div className="container-pro relative">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-10">
          <Reveal className="md:col-span-7">
            <div className="overline">// Strategic Partners</div>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight">
              Powered by the right partners.
            </h2>
          </Reveal>
          <Reveal variants={fadeUp} className="md:col-span-5">
            <p className="text-ink-secondary">
              We combine deep local execution with globally proven product and delivery partners so our clients get world-class outcomes, delivered locally.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-6">
          {partners.map((p) => (
            <Reveal key={p.name} variants={fadeUp}>
              <a
                href={p.url}
                target="_blank"
                rel="noreferrer noopener"
                data-testid={`partner-${p.name.toLowerCase()}`}
                className="group relative block border border-line rounded-2xl p-8 md:p-12 bg-white overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-brand-red/40 hover:shadow-[0_24px_64px_-20px_rgba(24,119,242,0.3)]"
              >
                <div className="absolute -top-20 -end-20 h-64 w-64 rounded-full bg-brand-red/[0.06] blur-3xl pointer-events-none group-hover:bg-brand-red/10 transition-colors" aria-hidden />
                <div className="absolute top-6 end-6 text-ink-muted group-hover:text-brand-red group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all">
                  <ArrowUpRight size={22} />
                </div>
                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand-red">{p.role}</div>
                <h3 className="mt-4 font-heading text-3xl md:text-5xl font-semibold tracking-tight">{p.name}</h3>
                <p className="mt-4 text-sm md:text-base text-ink-secondary leading-relaxed max-w-lg">{p.tagline}</p>
                <div className="mt-6 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-ink-secondary group-hover:text-brand-red transition-colors">
                  Visit partner site
                  <span className="h-px w-8 bg-current transition-all group-hover:w-12" aria-hidden />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
